module.exports = __webpack_public_path__ + "static/img/RW654-G_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RW654-G_1.png
// module id = YLxo
// module chunks = 0